module.exports = __webpack_public_path__ + "static/media/jeff_bezos.754d76b3.jpg";